import { Component, effect, signal } from '@angular/core';
import { OfficeTemplatesService } from '../services/office-templates.service';
import { Franchise } from 'src/app/models/franchise.model';
import { StandardTemplate } from 'src/app/models/standard-template.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { OfficeTemplatesPlansService } from '../services/office-templates-plans.service';
import { Plan, SSPlan } from 'src/app/models/plan.model';
import { Assembly } from 'src/app/models/assembly.model';
import { OfficeTemplatesAssembliesService } from '../services/office-templates-assemblies.service';
import { ToolbarModule } from 'primeng/toolbar';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { PlanSelectorComponent } from '@/landmark/operations/plan-selector/plan-selector.component';
import { AssemblyTableComponent } from '../../assemblies/assembly-table/assembly-table.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OfficesService } from '@/services/api/franchises.service';
import { PlansService } from '@/services/api/plans.service';
import { MenubarModule } from 'primeng/menubar';

@Component({
    selector: 'app-template-filter',
    imports: [
        MenubarModule,
        SelectModule,
        ButtonModule,
        TableModule,
        FormsModule,
        SidebarModule,
        DialogModule,
        ToastModule,
        PlanSelectorComponent,
        AssemblyTableComponent,
        ConfirmDialogModule
    ],
    template: `
<p-menubar>
    <ng-template #start>
      
    <div class="flex flex-col gap-4">
                    <div class="flex flex-wrap gap-4">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="office">Office</label>
                            <p-select [options]="offices" 
                appendTo="body"
                id="office"
                [ngModel]="officeFID" optionLabel="CityCode"
                    [style]="{'width':'100%'}" (onChange)="onSelectOffice($event.value)"
                    placeholder="Select an office" />
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="template">Template</label>
                            <p-select [options]="officeTemplatesService.filteredOpsTemplates()" 
                appendTo="body"
                id="template"
                [(ngModel)]="selectedTemplate"
                optionLabel="Description"
                (onChange)="onTemplateChange($event.value)"
                    [style]="{'width':'100%'}"
                    placeholder="Open a template" />
                        </div>
                    </div>
                </div>
   
    </ng-template>

    <ng-template #end>
    <p-button label="Default Plans" (onClick)="plansVisible = true" class="mr-2" [disabled]="!officeTemplatesService.selectedTemplate()"/>
        <p-button label="Add Assemblies" class="mr-2" (onClick)="showAssemblies()" [disabled]="!officeTemplatesService.selectedTemplate()"/>
        <p-button label="Create Template" (onClick)="createTemplateVisible = true" severity="success"/>
    </ng-template>
</p-menubar>

    <p-sidebar [(visible)]="plansVisible" position="right" styleClass="w-30rem" [blockScroll]="true">
        <div class="flex justify-content-between align-items-center mb-2">
            <span class="font-semibold text-xl">Plans Using This Template</span>
            <p-button severity="success" icon="pi pi-plus" size="small" (onClick)="addDefaultPlan()"/>
        </div>
        <p-table 
        [value]="officeTemplatesService.selectedTemplate()?.SSPlans || []" 
        [styleClass]="'p-datatable-sm'"
        sortField="Plans.PlanName" 
        [sortOrder]="1"
        selectionMode="single"
        [(selection)]="selectedPlan" 
        (selectionChange)="confirmRemovePlan()"
        >
            <ng-template pTemplate="body" let-plan>
                <tr [pSelectableRow]="plan">
                    <td>
                        <div class="flex justify-content-between align-items-center">
                            <span>{{ plan.Plans.PlanName }}</span>
                            <i class="pi pi-times" style="font-size: 1rem; color:red;"></i>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-sidebar>
    <p-dialog header="Create Template" [modal]="true" [(visible)]="createTemplateVisible" [style]="{ width: '30rem' }">
        <span class="p-text-secondary block mb-5">Create a new template.</span>
        <div class="flex align-items-center gap-3 mb-3">
            <label for="tempName" class="font-semibold w-6rem">Template Name</label>
            <input pInputText id="tempName" class="flex-auto" autocomplete="off" [(ngModel)]="templateName" />
        </div>
        <div class="flex align-items-center gap-3 mb-5">
            <label for="tempOffice" class="font-semibold w-6rem">Office</label>
            <p-select [options]="offices" 
                id="tempOffice"
                appendTo="body"
                class="flex-auto"
                [ngModel]="officeFID" optionLabel="CityCode" optionValue="FID"
                    [style]="{'width':'100%'}" (onChange)="onSelectOffice($event.value)"
                    placeholder="Select an office" />
        </div>
        <div class="flex justify-content-end gap-2">
            <p-button label="Cancel" severity="secondary" (onClick)="createTemplateVisible = false" />
            <p-button label="Create" (onClick)="createTemplateVisible = false" />
        </div>
    </p-dialog>
    <p-dialog header="Add Default Plan" [modal]="true" [(visible)]="addDefaultPlanVisible">
        <app-plan-selector [multiple]="true" [priceMode]="false" [filterPlanIds]="planFilter" (selectedPlansChange)="onAddDefaultPlans($event.plans)"></app-plan-selector>
    </p-dialog>
    <p-dialog header="Add Assemblies" [modal]="true" [(visible)]="addAssembliesVisible" [style]="{'min-height': '50vh', 'min-width': '75%'}">
        <app-assembly-table [outputMode]="true" [officeLocked]="true" (assembliesChanged)="onAddAssemblies($event)" [reset]="resetAssemblies" [aidFilters]="this.officeTemplatesService.selectedTemplate()?.StandardAssemblies || []"></app-assembly-table>
        <ng-template pTemplate="footer">
            <p-button 
                label="Save" 
                [outlined]="true" 
                severity="secondary" 
                (onClick)="onSaveAssemblies()"
              />
        </ng-template>
    </p-dialog>
    <p-toast />
<p-confirmDialog />
    `
})
export class TemplateFilterComponent {
  plansVisible:boolean = false;
  createTemplateVisible:boolean = false;
  assembliesToAdd: Assembly[] = [];

  selectedTemplate: StandardTemplate | null = null;
  addAssembliesVisible:boolean = false;

  templateName:string = '';
  templateFID:number = 0;

  planFilter:number[] = [];

  selectedPlan: SSPlan | null = null;
  addDefaultPlanVisible:boolean = false;
  removing: {
    planId: number,
    loading: boolean
  } | null = null;

  loadingPlans: boolean = false;
  loadingAssemblies: boolean = false;

  resetAssemblies = signal<boolean>(false);

  constructor(
    public officeTemplatesService: OfficeTemplatesService,
    public officesService: OfficesService,
    private messageService: MessageService,
    private officeTemplatesPlansService: OfficeTemplatesPlansService,
    private officeTemplatesAssembliesService: OfficeTemplatesAssembliesService,
    private confirmationService: ConfirmationService,
    public plansDataService: PlansService
  ) { 
      this.officeTemplatesService.getOpsTemplates();

    effect(() => {
      const selectedTemplate = this.officeTemplatesService.selectedTemplate();
      if(selectedTemplate !== null) {
        this.planFilter = selectedTemplate.SSPlans.map(plan => plan.PlanID);
        this.planFilter.push(1);
      }
      const offices = this.officesService.getFilteredOffices('Assemblies', 'edit');
      const templates = this.officeTemplatesService.opsTemplates();
      // if(offices.length > 0 && templates) {
      // this.filterOffices(offices);
      // }
    });
    effect(() => {
      const office = this.officesService.selectedOffice();
      if(office) {
        this.officeTemplatesService.setFIDFilter(office);
      }
    });
  }

  onTemplateChange(template: StandardTemplate) {
    this.officeTemplatesService.selectedTemplate.set(template);
    this.selectedTemplate = template;
  }

  get officeFID(): Franchise | null {
    return this.officeTemplatesService.officeFilter() || null;
  }

  set officeFID(office: Franchise) {
    this.officeTemplatesService.setFIDFilter(office);
  }

  get offices() {
    return this.officesService.getFilteredOffices('Assemblies', 'edit');
  }

  showAssemblies() {
    this.addAssembliesVisible = true;
  }

  onAddAssemblies(assemblies: Assembly[]) {
    console.log('adding assemblies', assemblies.length);
    this.assembliesToAdd = assemblies;
  }

  onSaveAssemblies() {
    this.loadingAssemblies = true;
    console.log('saving assemblies', this.assembliesToAdd);
    this.addAssembliesVisible = false;
    this.officeTemplatesAssembliesService.addAssemblies(this.assembliesToAdd).subscribe({
      next: () => {
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Assemblies added to template'});
        this.resetAssemblies.set(!this.resetAssemblies());
        this.assembliesToAdd = [];
        this.addAssembliesVisible = false;
      },
      error: () => {
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Failed to add assemblies to template'});
      },
      complete: () => {
        this.loadingAssemblies = false;
      }
    });
  }

  onSelectOffice(office: Franchise) {
    console.log('selecting office', office);
    this.officesService.setSelectedOffice(office);
    this.officeTemplatesService.setFIDFilter(office);
  }

  // filterOffices(offices: Franchise[]) {
  //   if(offices.length === 0) {
  //     return;
  //   }
  //   const templates = this.officeTemplatesService.opsTemplates();
  //   this.offices.set(offices.filter(office => templates.some(template => template.FID === office.FID)));
  //   if(this.officeTemplatesService.officeFilter() === null|| this.officeTemplatesService.officeFilter() === undefined) { 
  //     const office = this.offices[0]
  //     if(office) {
  //       this.officeTemplatesService.setFIDFilter(office);
  //     }
  //   }
  // }

  showPlans() {
    this.plansVisible = true;
  } 

  confirmRemovePlan() {
    if(this.selectedPlan !== null) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to remove this plan from the template?',
      accept: () => this.removePlan(this.selectedPlan)
    });
  }
  }

  removePlan(plan: SSPlan| null) {
    if(plan !== null) {
    this.removing = {
      planId: plan.PlanID,
      loading: true
    }
    this.officeTemplatesPlansService.removePlan(plan).subscribe({
      next: () => {
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Plan removed from template'});
      },
      error: () => {
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Failed to remove plan from template'});
      },
      complete: () => {
        this.removing = null;
      }

    })
  }
  }

  createTemplate() {
    const filter = this.officeTemplatesService.officeFilter()?.Standards_FID || this.officeTemplatesService.officeFilter()?.FID;
    this.officeTemplatesService.createTemplate(this.templateName, filter || 0)
      .subscribe({
        next: (template) => {
          this.messageService.add({severity:'success', summary: 'Success', detail: 'Template created successfully'});
        },
        error: (error) => {
          this.messageService.add({severity:'error', summary: 'Error', detail: 'Failed to create template'});
        },
        complete: () => {
          this.createTemplateVisible = false;
        }
      });
  }

  addDefaultPlan() {
    this.addDefaultPlanVisible = true;
  }

  onAddDefaultPlans(plans: Plan[]) {
    this.loadingPlans = true;
    this.officeTemplatesPlansService.addPlans(plans).subscribe({
      next: () => {
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Plan added to template'});
      },
      error: (error) => {
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Failed to create template'});
      },
      complete: () => {
        this.addDefaultPlanVisible = false;
        this.loadingPlans = false;
      }
    });
  }
}
